import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router"
import { LoadingService } from 'src/app/core/services/loading.service';
import { AuthService } from 'src/app/core/services/api/auth.service';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit {

  isAuthenticated: boolean;
  loading: boolean = false;
  siteId: number;

  constructor(
    private router: Router,
    public loadingService: LoadingService,
    private authService: AuthService, ) { }

  async ngOnInit(): Promise<void> {
    this.isAuthenticated = await this.authService.isAuthenticated();

    this.loadingService.loadingStarted.subscribe(() => {
      this.loading = true;
    });

    this.loadingService.loadingCompleted.subscribe(() => {
      this.loading = false;
    });
  }

  async login(): Promise<void> {
    await this.router.navigate(['/login']);
  }

  async logout(): Promise<void> {
    await this.authService.logout();
    await this.router.navigate(['/login']);
  }

}
